import React from 'react';
import 'react-virtualized/styles.css';
import { AutoSizer, Column, Table } from 'react-virtualized';

import columns from './columns';

import './Table.css';

function stringCompare(a, b) {
  const strA = a.toUpperCase(); // ignore upper and lowercase
  const strB = b.toUpperCase(); // ignore upper and lowercase
  if (strA < strB) {
    return -1;
  }
  if (strA > strB) {
    return 1;
  }
}

let timers = {};

class MarketsTableComponent extends React.PureComponent {
  static _getClassNameForKeyValue(key, value, oldData) {
    if (oldData) {
      const oldValue = oldData.value;
      const flashKeys = ['thirtyMinBaseVolumeAvgChange'];
      if (flashKeys.indexOf(key) > -1) {
        if (oldValue) {
          if (value > oldValue) {
            return ' highlightGreen ';
          }
          if (oldValue > value) {
            return ' highlightRed ';
          }
        }
      }
    }
    return null;
  }

  constructor(props) {
    super(props);
    this._sort = this._sort.bind(this);
    let dataKeys = columns.map(column => column.dataKey);
    dataKeys.push('ticker');
    dataKeys.push('key');
    this.state = {
      activeItem: 'BTC',
      sort: { sortBy: 'thirtyMinBaseVolumeAvgChange', sortDirection: 'DESC' },
      data: {},
      keys: [],
      dataKeys,
      columnOrder: columns,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { data, dataKeys, sort } = this.state;
    const { sortBy, sortDirection } = sort;
    const { search } = nextProps;
    const d = this._mergeData(nextProps, data, dataKeys);
    // this.trackChanges(data);
    const keys = this._getSortedKeys(data, sortBy, sortDirection, search);
    // const keys = Object.keys(data);
    this.setState({
      keys,
      data: d,
    });
  }

  render() {
    const { columnOrder, data, keys } = this.state;
    const rowGetter = ({ index }) => this._getDatum(keys, data, index);
    return (
      <div>
        <AutoSizer disableHeight>
          {({ width }) => (
            <Table
              ref="Table"
              headerHeight={50}
              height={500}
              overscanRowCount={10}
              rowClassName={this._rowClassName}
              rowHeight={60}
              rowGetter={rowGetter}
              rowCount={keys.length}
              // scrollToIndex={scrollToIndex}
              sort={this._sort}
              {...this.state.sort}
              width={width}
            >
              {columnOrder.map((d, index) => (
                <Column width={width} key={`col-${index}`} {...d} />
              ))}
            </Table>
          )}
        </AutoSizer>
      </div>
    );
  }

  trackChanges(data) {
    const keys = Object.keys(data);
    keys.forEach(key => {
      const payload = data[key];
      const propKeys = Object.keys(payload);
      propKeys.forEach(propKey => {
        const { className, changed } = payload[propKey];
        if (changed && className) {
          clearTimeout(timers[`${key}-${propKey}`]);
          // this.timers[`${key}-${propKey}`]
          timers[`${key}-${propKey}`] = setTimeout(() => {
            this.fireChange(key, propKey);
          }, 510);
        }
      });
    });
  }

  fireChange(key, propKey) {
    let { data } = this.state;
    const payload = Object.assign({}, data[key][propKey], {
      className: null,
      changed: false,
    });
    data[key][propKey] = payload;
    // console.log('Fire change: ', data[key][propKey]);
    delete timers[`${key}-${propKey}`];
    this.setState({
      data,
    });
  }

  _sort(sort) {
    const { data } = this.state;
    const keys = this._sortedKeys(data, sort.sortBy, sort.sortDirection);
    this.setState({
      keys,
      sort,
    });
  }

  _getDatum(keys, data, index) {
    return data[keys[index]];
  }

  _rowClassName({ index }) {
    if (index < 0) {
      return 'headerRow';
    } else {
      return index % 2 === 0 ? 'evenRow' : 'oddRow';
    }
  }

  _getSortedKeys(objects, sortBy, sortDirection, search) {
    const keys = Object.keys(objects);
    // console.log('Object keys', keys);
    const filtered = keys.filter(
      key =>
        objects[key].ticker.value
          .toLowerCase()
          .indexOf(search.toLowerCase().trim()) >= 0,
    );
    let data = {};
    filtered.forEach(key => (data[key] = objects[key]));
    return this._sortedKeys(data, sortBy, sortDirection);
  }

  _sortedKeys(data, sortBy, sortDirection) {
    let objects = Object.keys(data).map(key => data[key]);
    // console.log('Objects: ', objects, sortBy);
    objects.sort((a, b) => {
      // console.log(a[sortBy]);
      // console.log(b[sortBy]);
      const valA = a[sortBy].value;
      const valB = b[sortBy].value;
      // console.log('A AND B: ', valA, valB);
      if (sortDirection === 'DESC') {
        if (valA && isNaN(valA)) {
          if (sortBy === 'asset') {
            return stringCompare(valB.ticker, valA.ticker);
          }
          return stringCompare(valB, valA);
        }
        return valB - valA;
      }
      if (valA && isNaN(valA)) {
        if (sortBy === 'asset') {
          return stringCompare(valA.tickethoser, valB.ticker);
        }
        return stringCompare(valA, valB);
      }
      return valA - valB;
    });
    return objects.map(object => object.key.value);
  }

  _mergeData({ snapshots }, oldSnapshot, dataKeys) {
    const keys = Object.keys(snapshots);
    let objects = {};
    keys.forEach(key => {
      const result = snapshots[key];
      let formatted = {};
      if (!result.lastOrderPrice) {
        return;
      }
      Object.keys(result).forEach(k => {
        if (dataKeys.indexOf(k) < 0) {
          return;
        }
        const value = result[k];
        let oldData = null;
        if (oldSnapshot && oldSnapshot[key] && oldSnapshot[key][k]) {
          oldData = oldSnapshot[key][k];
        }
        let className = MarketsTableComponent._getClassNameForKeyValue(
          k,
          value,
          oldData,
        );
        // If no className change - set it to the current className
        const changed = className !== null;
        if (!className && oldData) {
          className = oldData.className;
        }
        let color = null;
        let label = value;
        if (!isNaN(value)) {
          color = Number(value) > 0 ? 'green' : 'red';
        }
        const finish = k.toLowerCase().indexOf('change') >= 0 ? '%' : '';
        label = `${label}${finish}`;
        formatted[k] = {
          label,
          value,
          className,
          changed,
          color,
        };
        if (changed && className) {
          clearTimeout(timers[`${key}-${k}`]);
          // this.timers[`${key}-${propKey}`]
          timers[`${key}-${k}`] = setTimeout(() => {
            this.fireChange(key, k);
          }, 510);
        }
      });
      objects[result.key] = formatted;
    });
    return objects;
  }
}

export default MarketsTableComponent;



// WEBPACK FOOTER //
// ./src/containers/Markets/components/MarketsTable/components/MarketsTableComponent/index.jsx